export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className?: string,
  text?: string
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text !== undefined) node.textContent = text;
  return node;
}

export function button(className: string, text: string, onClick: () => void): HTMLButtonElement {
  const node = el("button", className, text);
  node.type = "button";
  node.addEventListener("click", onClick);
  return node;
}

export function clear(node: HTMLElement): void {
  node.replaceChildren();
}

export function setCssVar(name: string, value: string | number): void {
  document.documentElement.style.setProperty(name, String(value));
}

export function safeUuid(): string {
  return crypto.randomUUID ? crypto.randomUUID() : `uuid-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
